import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUpinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.298 11.214L1.872 9.813l5.415-5.514a1 1 0 0 1 1.426 0l5.415 5.514-1.426 1.401L8 6.427l-4.702 4.787z",
		fill: "currentColor"
	})
});
export default SvgChevronUpinline;
